var irreducible = require('./irreducible');
var isFunction = require('./isFunction');

module.exports = irreducible('Function', isFunction);



//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/Function.js
// module id = 113
// module chunks = 114276838955818